import type { FaireProductEntity } from "../../entity_types/product";

export const p_43cf8c5f3t: FaireProductEntity = {
  token: "p_43cf8c5f3t",
  type: "product",
  name: "Chunky Knit Open Front Cardigan",
  brandToken: "b_qcqvf6ftyr",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e21da5a805862cbedc5a7177a05939d01f195e564101ce0b4825133d973f551f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/067297d1a4c8268e3978c92b6b1dfebd681c239eb5f4006c8b7862ca48f3827d.jpeg",
    "https://cdn.faire.com/fastly/5cf8201b9ec9bbfcc5ee811f26a55358740c1db24513d63484322f2d0d5ecd14.jpeg",
    "https://cdn.faire.com/fastly/da28f7a0903a385bb3c32dc0ae0eb2b8c5ca791ecbcfd477671bb18f6aa520d2.jpeg",
    "https://cdn.faire.com/fastly/22eff6be693875b4d47c443fd7f8741a3a934b5fa8e79cc0c16168e723791b3e.jpeg",
    "https://cdn.faire.com/fastly/7741d60ece75482127cdcef6228dc22d2e78110d3f39ee4fa9d72b5315bd07be.jpeg",
    "https://cdn.faire.com/fastly/d67ce6a95b0bafa6099523e74f185dfe7a4e5655bfef9943cd5cb275fa2e27cb.jpeg",
    "https://cdn.faire.com/fastly/4da43b135a1e466a08a33507d0be0674a97e857cc40b1c34a989916594329e19.jpeg",
    "https://cdn.faire.com/fastly/48a0ebb641e680fea326568fafb2d587b4de9d121d7063818585e9253407a764.jpeg",
    "https://cdn.faire.com/fastly/00f8e4aaecfc0f018c7d0a38dacf05d673483fede05374a319928e19ec85f23c.jpeg",
    "https://cdn.faire.com/fastly/e42b81a7b2d263cc523a0495a3d1d73855314bb551e010489de6451a1ad28929.jpeg",
    "https://cdn.faire.com/fastly/ed41e2fd44e63aee8478e52c4196f0e2a74a1489b6a25fc994ed79f54dfdc236.jpeg",
    "https://cdn.faire.com/fastly/c42799cceb7e8e0a74f8a16a421fadea1f448b524ec82b76c1850879bf756f96.jpeg",
    "https://cdn.faire.com/fastly/65bb61577be8aa0cce089e32c096adfcb28160b74164233ef7b076aa682ace34.jpeg",
    "https://cdn.faire.com/fastly/f69357818be0ad926502816919b1f23c11f905b627b9270b631744d768a51fa0.jpeg",
    "https://cdn.faire.com/fastly/405535d8103eacce7b453b80239e03508bd0334ba89c621ddf5b6ebe67b6fc1e.jpeg",
    "https://cdn.faire.com/fastly/b4c60151d97cef531e905d9112af7cd06a2d341a80fdc90366808094211cb681.jpeg",
    "https://cdn.faire.com/fastly/78d8f161254dbfad4718f9b9807df0c0d13edbfd8d58bf0eea66b3bfd52f4d78.jpeg",
    "https://cdn.faire.com/fastly/198ed630f1ec85e99b29e8252ff54c7b8e604bf9a62551bd7f5e7842ffd183a1.jpeg",
    "https://cdn.faire.com/fastly/dc6f1649cbcf2370c721cd746a70a4e5ffb5ff8a4e1a425320b4c5b0c58ee6ac.jpeg",
  ],
  priceDollars: 34.63,
  description:
    "Cozy chunky knit cardigan with an open front. Relaxed fit, ideal for layering over casual outfits.\n\nFabric: 100% acrylic\nWeight: 1.54 lb",
  tags: [],
  msrpDollars: 69.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:22.155Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
